if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends HTMLElement {
      constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        this.initializeThumbnailClickLogic();
      }

      show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
        this.showActiveMedia();
      }

      hide() {
        // console.log('Modal is closing');
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      handleOutsideClick(event) {
        const thumbnailSlider = this.querySelector('thumbnail-slider');
        if (thumbnailSlider && !thumbnailSlider.contains(event.target)) {
          this.hide();
        }
      }

      initializeThumbnailClickLogic() {
        const thumbnails = this.querySelectorAll('.thumbnail-item');
        // console.log(thumbnails);
        const mainImageContainer = this.querySelector('.product-media__main');
    
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', () => {
                thumbnails.forEach(thumb => {
                    const img = thumb.querySelector('img');
                    if (img) {
                        img.classList.remove('active');
                    }
                });
                
                const imgElement = thumbnail.querySelector('img');
                if (imgElement) {
                    imgElement.classList.add('active');
    
                    const newSrc = imgElement.src;
                    const newSrcset = imgElement.srcset;
                    const mainImage = mainImageContainer.querySelector('img');
                    if (mainImage) {
                        mainImage.src = newSrc;
                        mainImage.srcset = newSrcset;
                    } else {
                        console.error('Main image not found!');
                    }
                } else {
                    console.error('Image element not found inside the thumbnail!');
                }
            });
        });
      }
    }
  );
}
